import {SnSButton} from "./SnSButton.js";

export class AppleButton extends SnSButton {
    setup() {
        this.$props.isRender = !!window.appleApiAvailable
    }

    getButtonDataJson() {
        return {
            snsType: "apple",
            id: "appleLoginButton",
            className: `login-apple`,
            buttonText: i18next.t(login.applestrt)
        }
    }

    setEvent() {
        const buttonId = this.getButtonDataJson().id;
        const AppleLogin = Mutil.requireIIFE("AppleLogin");
        this.addEvent("click.prevent", `#${buttonId}`, AppleLogin.clickAppleLoginButton);
    }

}